// FEEDFPFF live-feed refresh. The offcanvas body (`[data-feed-entries]`) is
// server-rendered on load; while the panel is OPEN this Alpine component polls
// the feed's `.ajax` fragment (`_ajax/feedfpff_full` → the day-grouped entries)
// every 5 minutes and swaps the result in, so a feed left open keeps current
// without a page reload. Cheap by design: it runs ONLY while the panel is
// visible (start()/stop() driven from the offcanvas store via x-effect) and
// skips ticks while the tab is hidden, refetching once on re-show. The server
// response is minute-bucketed + ETag'd, so concurrent visitors share one cached
// render. Markup: the entries container carries `x-data="feedRefresh"`,
// `data-feed-url="<feedURL>.ajax"`, and
// `x-effect="$store.offcanvas.isOpen('feedfpff') ? start() : stop()"`.
const REFRESH_MS = 5 * 60 * 1000;

export const feedRefresh = () => ({
  _timer: 0 as number,
  _onVisible: null as null | (() => void),

  start(): void {
    const url = ((this as any).$el as HTMLElement).dataset.feedUrl;
    if (!url) return;
    this.refresh(url); // fresh content the moment the panel opens (page HTML may be cached)
    this.stop(); // never stack intervals across repeated opens
    this._timer = window.setInterval(() => {
      if (!document.hidden) this.refresh(url);
    }, REFRESH_MS);
    this._onVisible = (): void => {
      if (!document.hidden) this.refresh(url);
    };
    document.addEventListener('visibilitychange', this._onVisible);
  },

  stop(): void {
    if (this._timer) {
      window.clearInterval(this._timer);
      this._timer = 0;
    }
    if (this._onVisible) {
      document.removeEventListener('visibilitychange', this._onVisible);
      this._onVisible = null;
    }
  },

  refresh(url: string): void {
    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((html) => {
        ((this as any).$el as HTMLElement).innerHTML = html;
      })
      .catch(() => {
        /* keep the last good render on a failed / slow refresh */
      });
  },
});
